module.exports = __webpack_public_path__ + "images/element-icons.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/element-ui/lib/theme-chalk/fonts/element-icons.ttf
// module id = 944
// module chunks = 2